import { PromoPackAssetType } from 'api';
import { optInAssets } from './constants';

export function isOptInAsset(assetType: PromoPackAssetType | undefined) {
  if (assetType === undefined) return undefined;
  return optInAssets.includes(assetType);
}
